// Import the patch before using react-virtualized components
import "./react-virtualized-patch";
import "./main.css";
import appStores from "./appStoresConfig";
import { setupInjectStores } from "./components/RootStore/injectStores";
import serviceStores from "serviceStoresConfig";

import { pwaRegistration } from "./pwaUtils";
import { renderApp } from "./renderApp";
import { createRootStore } from "./createRootStore";

const rootStore = createRootStore();

pwaRegistration(rootStore);

setupInjectStores(appStores, serviceStores)
  .then(() => {
    // Stores setup complete
    renderApp(rootStore);
  })
  .catch((error) => {
    console.error("Error setting up stores", error);
  });
